module.exports = __webpack_public_path__ + "img/docma-logo-white-red.9756120e.svg";